export default __webpack_public_path__ + "static/Entenda0015-ecda09d1d0059cd4707077677a58e428.jpg";